import { defineMessages } from 'react-intl';

export const i18n = defineMessages({
  title: {
    id: 'fdaConfirmation.title',
    defaultMessage: 'User Confirmation Required',
  },
  intendedUse: {
    id: 'fdaConfirmation.intendedUse',
    defaultMessage:
      'Diagnocat is intended only for use by licensed dental professionals with training and experience in interpreting CBCT radiographs.',
  },
  adjunctiveAid: {
    id: 'fdaConfirmation.adjunctiveAid',
    defaultMessage:
      'The software is an adjunctive aid and must not be used as the sole basis for diagnosis or treatment decisions.',
  },
  pleaseConfirm: {
    id: 'fdaConfirmation.pleaseConfirm',
    defaultMessage:
      'Please confirm that you meet these criteria before proceeding.',
  },
  checkboxLabel: {
    id: 'fdaConfirmation.checkboxLabel',
    defaultMessage:
      'I confirm that I am a licensed dental professional with training and experience in interpreting CBCT radiographs',
  },
});
